import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "Redux/actions";
import { clientQuery } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    coaches: [],
    loadingCoach: false,
    isLoaded: false,
};

const route = 'modules/driverPerformance/views/cases/modals/advancedFilters/redux/slice';

const searchDriverPerformanceCasesCoach = createAsyncThunk(
    "driverPerformance/casesTab/advanceFilter/searchDriverPerformanceCasesCoach",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const response = await clientQuery(
                searchDriverPerformanceCasesCoach.query,
                {},
                endpoints.GRAPHQL_GENERAL_V2
            );

            if (!response?.data) {
                throw 'searchDriverPerformanceCasesCoach : No data found';
            }

            let data = response?.data?.items || [];

            if (data) {
                const coaches = data?.reduce((acc, item) => {
                    if (item?.isSupervisor === true) {
                        acc.push({
                            ...item,
                            fullname: `${item?.firstName} ${item?.lastName}` || item?.userName
                        });
                    }
                    return acc;
                }, []).sort((a, b) => a.fullname.localeCompare(b.fullname));
                return coaches;
            } else {
                return [];
            }
        } catch (exc) {
            ExceptionManager(exc, route, "searchDriverPerformanceCasesCoach");
            return rejectWithValue(exc);
        }
    }
);

searchDriverPerformanceCasesCoach.query = `
    query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
            data: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    firstName
                    lastName
                    userName
                    isSupervisor
                }
                total
            }
        }`;

export { searchDriverPerformanceCasesCoach };

//Slice
const driverPerformanceCasesTabAdvancedFiltersRedux = createSlice({
    name: "driverPerformance/advancedFilters",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalAdvancedFilters: (state, action) => {
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //searchDriverPerformanceCasesCoach
        builder.addCase(searchDriverPerformanceCasesCoach.pending, (state) => {
            state.loadingCoach = true;
            state.error = null;
        });
        builder.addCase(searchDriverPerformanceCasesCoach.fulfilled, (state, action) => {
            state.loadingCoach = false;
            state.isLoaded = true;
            state.coaches = action.payload;
        });
        builder.addCase(searchDriverPerformanceCasesCoach.rejected, (state, action) => {
            state.loadingCoach = false;
            state.isLoaded = false;
            state.error = action.payload;
            state.coaches = [];
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceCasesTabAdvancedFiltersRedux;

// Extract and export each action creator by name
export const { openModalAdvancedFilters, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
